/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { DetailEvacuationDto } from '../models/detail-evacuation-dto';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des détails des demandes d'évacuation
 */
@Injectable({
  providedIn: 'root',
})
export class DetailEvacuationService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation detailEvacuationGetList
   */
  static readonly DetailEvacuationGetListPath = '/api/detail-evacuation/list/{evacuationId}';

  /**
   * Renvoie la liste des détails pour l'évacuation spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `detailEvacuationGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  detailEvacuationGetList$Response(params: {
    evacuationId: number;
  }): Observable<StrictHttpResponse<Array<DetailEvacuationDto>>> {

    const rb = new RequestBuilder(this.rootUrl, DetailEvacuationService.DetailEvacuationGetListPath, 'get');
    if (params) {
      rb.path('evacuationId', params.evacuationId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DetailEvacuationDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des détails pour l'évacuation spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `detailEvacuationGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  detailEvacuationGetList(params: {
    evacuationId: number;
  }): Observable<Array<DetailEvacuationDto>> {

    return this.detailEvacuationGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DetailEvacuationDto>>) => r.body as Array<DetailEvacuationDto>)
    );
  }

  /**
   * Path part for operation detailEvacuationLoadList
   */
  static readonly DetailEvacuationLoadListPath = '/api/detail-evacuation/load-list/{evacuationId}';

  /**
   * Renvoie la liste des détails de l'évacuation spécifiée (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `detailEvacuationLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  detailEvacuationLoadList$Response(params: {

    /**
     * Identifiant de l&#x27;évacuation
     */
    evacuationId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, DetailEvacuationService.DetailEvacuationLoadListPath, 'post');
    if (params) {
      rb.path('evacuationId', params.evacuationId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des détails de l'évacuation spécifiée (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `detailEvacuationLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  detailEvacuationLoadList(params: {

    /**
     * Identifiant de l&#x27;évacuation
     */
    evacuationId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.detailEvacuationLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation detailEvacuationGet
   */
  static readonly DetailEvacuationGetPath = '/api/detail-evacuation/{id}';

  /**
   * Renvoie le détail du l'évacuation spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `detailEvacuationGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  detailEvacuationGet$Response(params: {

    /**
     * Identifiant du détail de l&#x27;évacuation
     */
    id: number;
  }): Observable<StrictHttpResponse<DetailEvacuationDto>> {

    const rb = new RequestBuilder(this.rootUrl, DetailEvacuationService.DetailEvacuationGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DetailEvacuationDto>;
      })
    );
  }

  /**
   * Renvoie le détail du l'évacuation spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `detailEvacuationGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  detailEvacuationGet(params: {

    /**
     * Identifiant du détail de l&#x27;évacuation
     */
    id: number;
  }): Observable<DetailEvacuationDto> {

    return this.detailEvacuationGet$Response(params).pipe(
      map((r: StrictHttpResponse<DetailEvacuationDto>) => r.body as DetailEvacuationDto)
    );
  }

  /**
   * Path part for operation detailEvacuationPut
   */
  static readonly DetailEvacuationPutPath = '/api/detail-evacuation/{id}';

  /**
   * Met à jour le détail du l'évacuation spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `detailEvacuationPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  detailEvacuationPut$Response(params: {

    /**
     * Identifiant du détail de l&#x27;évacuation à mettre à jour
     */
    id: number;

    /**
     * Détail du l'évacuation
     */
    body: DetailEvacuationDto
  }): Observable<StrictHttpResponse<DetailEvacuationDto>> {

    const rb = new RequestBuilder(this.rootUrl, DetailEvacuationService.DetailEvacuationPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DetailEvacuationDto>;
      })
    );
  }

  /**
   * Met à jour le détail du l'évacuation spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `detailEvacuationPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  detailEvacuationPut(params: {

    /**
     * Identifiant du détail de l&#x27;évacuation à mettre à jour
     */
    id: number;

    /**
     * Détail du l'évacuation
     */
    body: DetailEvacuationDto
  }): Observable<DetailEvacuationDto> {

    return this.detailEvacuationPut$Response(params).pipe(
      map((r: StrictHttpResponse<DetailEvacuationDto>) => r.body as DetailEvacuationDto)
    );
  }

  /**
   * Path part for operation detailEvacuationDelete
   */
  static readonly DetailEvacuationDeletePath = '/api/detail-evacuation/{id}';

  /**
   * Supprime l'alerte spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `detailEvacuationDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  detailEvacuationDelete$Response(params: {

    /**
     * Identifiant de l&#x27;alerte à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, DetailEvacuationService.DetailEvacuationDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime l'alerte spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `detailEvacuationDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  detailEvacuationDelete(params: {

    /**
     * Identifiant de l&#x27;alerte à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.detailEvacuationDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation detailEvacuationPost
   */
  static readonly DetailEvacuationPostPath = '/api/detail-evacuation/{evacuationId}';

  /**
   * Crée le détail de l'évacuation spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `detailEvacuationPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  detailEvacuationPost$Response(params: {

    /**
     * Identifiant de l&#x27;évacuation sur laquelle ajouter le détail
     */
    evacuationId: number;

    /**
     * Détail du l'évacuation
     */
    body: DetailEvacuationDto
  }): Observable<StrictHttpResponse<DetailEvacuationDto>> {

    const rb = new RequestBuilder(this.rootUrl, DetailEvacuationService.DetailEvacuationPostPath, 'post');
    if (params) {
      rb.path('evacuationId', params.evacuationId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DetailEvacuationDto>;
      })
    );
  }

  /**
   * Crée le détail de l'évacuation spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `detailEvacuationPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  detailEvacuationPost(params: {

    /**
     * Identifiant de l&#x27;évacuation sur laquelle ajouter le détail
     */
    evacuationId: number;

    /**
     * Détail du l'évacuation
     */
    body: DetailEvacuationDto
  }): Observable<DetailEvacuationDto> {

    return this.detailEvacuationPost$Response(params).pipe(
      map((r: StrictHttpResponse<DetailEvacuationDto>) => r.body as DetailEvacuationDto)
    );
  }

  /**
   * Path part for operation detailEvacuationPost2
   */
  static readonly DetailEvacuationPost2Path = '/api/detail-evacuation';

  /**
   * Crée l'entité spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `detailEvacuationPost2()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  detailEvacuationPost2$Response(params: {

    /**
     * Entité
     */
    body: DetailEvacuationDto
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DetailEvacuationService.DetailEvacuationPost2Path, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Crée l'entité spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `detailEvacuationPost2$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  detailEvacuationPost2(params: {

    /**
     * Entité
     */
    body: DetailEvacuationDto
  }): Observable<void> {

    return this.detailEvacuationPost2$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
